import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type InviteAccountConnectionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.InviteAccountConnectionInput;
}>;

export type InviteAccountConnectionMutationResult = { __typename?: 'Mutation' } & {
  inviteAccountConnection?: GraphQLTypes.Maybe<
    { __typename?: 'InviteAccountConnectionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const InviteAccountConnectionDocument = gql`
  mutation inviteAccountConnection($input: InviteAccountConnectionInput!) {
    inviteAccountConnection(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
